(function linkArrow() {
  const script = document.getElementById('link-arrow-loader');
  if (!(script instanceof HTMLElement)) return;
  const arrowSrc = `${script.dataset.arrowSrc ?? ''}`;
  if (arrowSrc.length === 0) return;

  const SELECTOR = 'a.size-style.link, a.size-style.button-secondary, button.size-style.button-secondary';

  /**
   * @param {Element} element
   */
  function isInFooter(element) {
    return Boolean(element.closest('footer'));
  }

  /**
   * @param {HTMLElement} control
   * @param {HTMLImageElement} arrow
   */
  function wrapArrowForControl(control, arrow) {
    if (control instanceof HTMLAnchorElement) {
      const arrowLink = document.createElement('a');
      arrowLink.className = 'link-arrow-link';
      arrowLink.href = control.href;
      if (control.target) arrowLink.target = control.target;
      if (control.rel) arrowLink.rel = control.rel;
      if (control.hasAttribute('download')) {
        arrowLink.download = control.download;
      }
      arrowLink.setAttribute('aria-hidden', 'true');
      arrowLink.tabIndex = -1;
      arrowLink.append(arrow);
      return arrowLink;
    }

    const hit = document.createElement('span');
    hit.className = 'link-arrow-link';
    hit.setAttribute('aria-hidden', 'true');
    hit.tabIndex = -1;
    hit.append(arrow);
    hit.addEventListener('click', () => {
      control.click();
    });
    return hit;
  }

  /**
   * @param {ParentNode} [root]
   */
  function decorateLinkArrows(root = document) {
    for (const element of root.querySelectorAll(SELECTOR)) {
      if (!(element instanceof HTMLElement)) continue;
      if (element.dataset.linkArrowDecorated === 'true') continue;
      if (isInFooter(element)) continue;

      if (element.parentElement?.classList.contains('link-arrow-group')) continue;

      const group = document.createElement('span');
      group.className = 'link-arrow-group';

      const arrow = document.createElement('img');
      arrow.src = arrowSrc;
      arrow.alt = '';
      arrow.className = 'link-arrow';
      arrow.width = 64;
      arrow.height = 64;
      arrow.decoding = 'async';
      arrow.loading = 'lazy';

      const arrowControl = wrapArrowForControl(element, arrow);

      element.parentNode?.insertBefore(group, element);
      group.append(element, arrowControl);
      element.dataset.linkArrowDecorated = 'true';
    }
  }

  function init() {
    decorateLinkArrows();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => {
    if (event.target instanceof HTMLElement) {
      decorateLinkArrows(event.target);
    }
  });

  window.addEventListener('pagereveal', init);
})();
